import { render, staticRenderFns } from "./VideoMedia.vue?vue&type=template&id=2fb1dd20&scoped=true"
import script from "./VideoMedia.vue?vue&type=script&lang=js"
export * from "./VideoMedia.vue?vue&type=script&lang=js"
import style0 from "./VideoMedia.vue?vue&type=style&index=0&id=2fb1dd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1dd20",
  null
  
)

export default component.exports